FileDroppableMixin = require 'mixins/file-droppable'

App.StoryFramePhotoComponent = Em.Component.extend [
  FileDroppableMixin
]...,
  classNames: [ 'story-frame-photo' ]
  classNameBindings: [ 'disabled:-disabled', 'hasOverlay:has-overlay']

  # Дочерние компоненты
  fileInput: null

  # ----
  # Заполнение картинкой
  # ----
  attributeBindings: [ 'style' ]

  style: (->
    photo = @get('storyFrame.photo.original')
    result = if photo then "background-image: url(#{photo})" else ''
    result.htmlSafe()
  ).property('storyFrame.photo.original')

  hasOverlay: (->
    storyFrame = @get('storyFrame')
    storyFrame.frame_variant is 'image' and (storyFrame.title or storyFrame.description or storyFrame.disclaimer)
  ).property('storyFrame.frame_variant', 
    'storyFrame.title', 
    'storyFrame.description', 
    'storyFrame.disclaimer')

  # ----
  # Текущее состояние компонента
  # ----
  activeState: (->
    return 'initial'   if @get('disabled')
    return 'loading'   if @get('isLoading')
    return 'drag-over' if @get('isDraggedOver')
    return 'initial'
  ).property(
    'disabled'
    'isLoading',
    'isDraggedOver')

  isStateLoading:  Em.computed.equal('activeState', 'loading')
  isStateDragOver: Em.computed.equal('activeState', 'drag-over')
  isStateInitial:  Em.computed.equal('activeState', 'initial')

  # ----
  # Внутренние свойства
  # ----
  hasPhoto: Em.computed.or('storyFrame.photo.original', 'isLoading')
  isLoading: false
  loadingProgress: 0

  innerBarStyle: (-> "width: #{@get('loadingProgress')}%;".htmlSafe() ).property('loadingProgress')

  actions:
    filesDropped: (files) ->
      return if @get('isLoading')
      @get('fileInput').send('filesSelected', files)
      false

    uploadPhoto: (file) ->
      banner = @get('banner')
      storyFrame = @get('storyFrame')
      @set('isLoading', true)
      banner.fileUpload("/story_frames/#{storyFrame.id}/photo", file)
      .on('progress', (p) => @set('loadingProgress', p))
      .then =>
        banner.reload()
      .catch (e) =>
        alert("Ошибка при загрузке файла. Возможно превышен максимальный размер — 15Мб")
      .finally =>
        @set('loadingProgress', 0)
        @set('isLoading', false)

      false

    openFileDialog: ->
      @get('fileInput').openDialog()
      false
